import React, { useState, useEffect } from "react";
import styles from "./PerfilEquipe.module.css";
import { FaUser, FaCamera } from "react-icons/fa";
import FooterOpcoes from "../../cliente/components/FooterOpcoes";
import HeaderPageEquipe from "../components/HeaderPageEquipe";
import { useNavigate } from "react-router-dom";

const PerfilEquipe = () => {
  const navigate = useNavigate();
  const nomeEstabelecimento = localStorage.getItem("nomeEstabelecimento");
  const [funcionario, setFuncionario] = useState({
    nome: "",
    email: "",
    telefone: "",
    foto_perfil: null
  });
  const [carregando, setCarregando] = useState(true);
  const [mensagem, setMensagem] = useState({ tipo: "", texto: "" });

  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    buscarDadosFuncionario();
  }, []);

  const buscarDadosFuncionario = async () => {
    try {
      const id_funcionario = localStorage.getItem("id_funcionario");

      if (!id_funcionario) {
        console.error("ID do funcionário não encontrado");
        return;
      }

      const response = await fetch(`${API_URL}/funcionario/${id_funcionario}`);

      if (!response.ok) {
        throw new Error("Erro ao buscar dados do funcionário");
      }

      const data = await response.json();
      setFuncionario(data);
      setCarregando(false);
    } catch (error) {
      console.error("Erro ao buscar dados:", error);
      setMensagem({ tipo: "erro", texto: "Erro ao carregar dados do perfil" });
      setCarregando(false);
    }
  };

  const handleFotoChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validar tipo de arquivo
    if (!file.type.startsWith('image/')) {
      setMensagem({ tipo: "erro", texto: "Por favor, selecione uma imagem válida" });
      return;
    }

    // Validar tamanho (máx 5MB)
    if (file.size > 5 * 1024 * 1024) {
      setMensagem({ tipo: "erro", texto: "A imagem deve ter no máximo 5MB" });
      return;
    }

    try {
      const id_funcionario = localStorage.getItem("id_funcionario");
      const formData = new FormData();
      formData.append("foto", file);

      const response = await fetch(`${API_URL}/funcionario/${id_funcionario}/foto`, {
        method: "POST",
        body: formData
      });

      if (!response.ok) {
        throw new Error("Erro ao fazer upload da foto");
      }

      const data = await response.json();
      setFuncionario(prev => ({ ...prev, foto_perfil: data.foto_perfil }));
      setMensagem({ tipo: "sucesso", texto: "Foto atualizada com sucesso!" });

      // Limpar mensagem após 3 segundos
      setTimeout(() => setMensagem({ tipo: "", texto: "" }), 3000);
    } catch (error) {
      console.error("Erro ao fazer upload:", error);
      setMensagem({ tipo: "erro", texto: "Erro ao atualizar foto" });
    }
  };

  const handleSair = () => {
    localStorage.removeItem("id_funcionario");
    localStorage.removeItem("nome");
    localStorage.removeItem("email");
    localStorage.removeItem("tipo_usuario");
    navigate("/home");
  };

  if (carregando) {
    return (
      <div className={styles.container}>
        <HeaderPageEquipe
          nomeEstabelecimento={nomeEstabelecimento}
          nomePage="Meu Perfil"
        />
        <div className={styles.contentWrapper}>
          <p className={styles.carregando}>Carregando...</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <HeaderPageEquipe
        nomeEstabelecimento={nomeEstabelecimento}
        nomePage="Meu Perfil"
      />

      <div className={styles.contentWrapper}>
        {/* Mensagem de feedback */}
        {mensagem.texto && (
          <div className={`${styles.mensagem} ${styles[mensagem.tipo]}`}>
            {mensagem.texto}
          </div>
        )}

        {/* Card de foto e nome */}
        <section className={styles.cardPerfil}>
          <div className={styles.fotoContainer}>
            <div className={styles.fotoWrapper}>
              {funcionario.foto_perfil ? (
                <img
                  src={`${API_URL}${funcionario.foto_perfil}`}
                  alt="Foto de perfil"
                  className={styles.fotoPerfil}
                />
              ) : (
                <div className={styles.avatarPlaceholder}>
                  <FaUser />
                </div>
              )}
              <label htmlFor="inputFoto" className={styles.btnCamera}>
                <FaCamera />
                <input
                  id="inputFoto"
                  type="file"
                  accept="image/*"
                  onChange={handleFotoChange}
                  className={styles.inputFoto}
                />
              </label>
            </div>
          </div>

          <div className={styles.infoBasica}>
            <h2>{funcionario.nome}</h2>
            <p className={styles.tipoUsuario}>{funcionario.tipo_usuario || 'Funcionário'}</p>
          </div>
        </section>

        {/* Dados do perfil (somente leitura) */}
        <section className={styles.dadosPerfil}>
          <h3>Informações pessoais</h3>

          <div className={styles.camposPerfil}>
            <div className={styles.campo}>
              <label>Nome completo</label>
              <p>{funcionario.nome}</p>
            </div>

            <div className={styles.campo}>
              <label>Email</label>
              <p>{funcionario.email}</p>
            </div>

            <div className={styles.campo}>
              <label>Telefone</label>
              <p>{funcionario.telefone || "Não informado"}</p>
            </div>
          </div>
          <p className={styles.avisoSomenteLeitura}>Para alterar esses dados, fale com a administração do estabelecimento.</p>
        </section>

        {/* Sessão */}
        <section className={styles.sessao}>
          <button className={styles.btnSair} onClick={handleSair}>
            Sair da conta
          </button>
        </section>
      </div>

      <FooterOpcoes typeView="equipe" />
    </div>
  );
};

export default PerfilEquipe;
